/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * PASSWD
 * Passwd backend
 * OpenAPI spec version: 2.28.0
 */
export type ApiKey = {
    id: string;
    name: string;
    /** Masked version of the key, showing only last 4 characters */
    maskedKey: string;
    createdAt: string;
    /** @nullable */
    lastUsedAt?: string | null;
};

export type ApiKeyDetailAllOf = {
    /** The full API key, shown only once on creation */
    key: string;
};

export type ApiKeyDetail = ApiKey & ApiKeyDetailAllOf;

export type ApiKeyInput = {
    /**
     * @minLength 1
     * @maxLength 100
     */
    name: string;
};

export type PublicKeyCredentialCreationOptionsRp = {
    /** Relying party ID (typically the domain). Must NOT be used as origin — the two are independent in WebAuthn. */
    id: string;
    /** Human-readable name of the relying party */
    name: string;
};

export type PublicKeyCredentialCreationOptionsUser = {
    /** User identifier */
    id: string;
    /** Username */
    name: string;
    /** User's display name */
    displayName: string;
};

export type PublicKeyCredentialCreationOptionsPubKeyCredParamsItemType =
    (typeof PublicKeyCredentialCreationOptionsPubKeyCredParamsItemType)[keyof typeof PublicKeyCredentialCreationOptionsPubKeyCredParamsItemType];

 
export const PublicKeyCredentialCreationOptionsPubKeyCredParamsItemType = {
    'public-key': 'public-key',
} as const;

export type PublicKeyCredentialCreationOptionsPubKeyCredParamsItem = {
    type: PublicKeyCredentialCreationOptionsPubKeyCredParamsItemType;
    /** COSE algorithm identifier */
    alg: number;
};

export type PublicKeyCredentialCreationOptionsAuthenticatorSelectionAuthenticatorAttachment =
    (typeof PublicKeyCredentialCreationOptionsAuthenticatorSelectionAuthenticatorAttachment)[keyof typeof PublicKeyCredentialCreationOptionsAuthenticatorSelectionAuthenticatorAttachment];

 
export const PublicKeyCredentialCreationOptionsAuthenticatorSelectionAuthenticatorAttachment = {
    platform: 'platform',
    'cross-platform': 'cross-platform',
} as const;

export type PublicKeyCredentialCreationOptionsAuthenticatorSelectionUserVerification =
    (typeof PublicKeyCredentialCreationOptionsAuthenticatorSelectionUserVerification)[keyof typeof PublicKeyCredentialCreationOptionsAuthenticatorSelectionUserVerification];

 
export const PublicKeyCredentialCreationOptionsAuthenticatorSelectionUserVerification = {
    required: 'required',
    preferred: 'preferred',
    discouraged: 'discouraged',
} as const;

export type PublicKeyCredentialCreationOptionsAuthenticatorSelection = {
    authenticatorAttachment?: PublicKeyCredentialCreationOptionsAuthenticatorSelectionAuthenticatorAttachment;
    userVerification?: PublicKeyCredentialCreationOptionsAuthenticatorSelectionUserVerification;
};

export type PublicKeyCredentialCreationOptions = {
    rp: PublicKeyCredentialCreationOptionsRp;
    /** HTTPS origin where the credential will be presented (e.g. https://app.example.com).
Distinct from rp.id; one rpId can serve multiple origins. Used verbatim as
clientDataJSON.origin — must match the verifier's expected origin exactly.
 */
    origin: string;
    user: PublicKeyCredentialCreationOptionsUser;
    /** Base64url-encoded challenge */
    challenge: string;
    pubKeyCredParams: PublicKeyCredentialCreationOptionsPubKeyCredParamsItem[];
    authenticatorSelection: PublicKeyCredentialCreationOptionsAuthenticatorSelection;
};

export type PublicKeyCredentialGetOptionsUserVerification =
    (typeof PublicKeyCredentialGetOptionsUserVerification)[keyof typeof PublicKeyCredentialGetOptionsUserVerification];

 
export const PublicKeyCredentialGetOptionsUserVerification = {
    required: 'required',
    preferred: 'preferred',
    discouraged: 'discouraged',
} as const;

export type PublicKeyCredentialGetOptionsAllowCredentialsItemType =
    (typeof PublicKeyCredentialGetOptionsAllowCredentialsItemType)[keyof typeof PublicKeyCredentialGetOptionsAllowCredentialsItemType];

 
export const PublicKeyCredentialGetOptionsAllowCredentialsItemType = {
    'public-key': 'public-key',
} as const;

export type PublicKeyCredentialGetOptionsAllowCredentialsItemTransportsItem =
    (typeof PublicKeyCredentialGetOptionsAllowCredentialsItemTransportsItem)[keyof typeof PublicKeyCredentialGetOptionsAllowCredentialsItemTransportsItem];

 
export const PublicKeyCredentialGetOptionsAllowCredentialsItemTransportsItem = {
    usb: 'usb',
    nfc: 'nfc',
    ble: 'ble',
    internal: 'internal',
    hybrid: 'hybrid',
} as const;

export type PublicKeyCredentialGetOptionsAllowCredentialsItem = {
    /** Base64url-encoded credential ID */
    id: string;
    type: PublicKeyCredentialGetOptionsAllowCredentialsItemType;
    transports?: PublicKeyCredentialGetOptionsAllowCredentialsItemTransportsItem[];
};

export type PublicKeyCredentialGetOptions = {
    /** Base64url-encoded challenge */
    challenge: string;
    /** Relying party ID (typically the domain). Must match the rpId stored at registration. */
    rpId: string;
    /** HTTPS origin used in clientDataJSON. Its host must be the rpId stored at
registration or a subdomain of it. Other origins are rejected with e1042.
 */
    origin: string;
    userVerification?: PublicKeyCredentialGetOptionsUserVerification;
    allowCredentials: PublicKeyCredentialGetOptionsAllowCredentialsItem[];
};

export type AttestationResponseType = (typeof AttestationResponseType)[keyof typeof AttestationResponseType];

 
export const AttestationResponseType = {
    'public-key': 'public-key',
} as const;

export type AttestationResponseResponseTransportsItem =
    (typeof AttestationResponseResponseTransportsItem)[keyof typeof AttestationResponseResponseTransportsItem];

 
export const AttestationResponseResponseTransportsItem = {
    usb: 'usb',
    nfc: 'nfc',
    ble: 'ble',
    internal: 'internal',
    hybrid: 'hybrid',
} as const;

export type AttestationResponseResponse = {
    /** Base64url-encoded attestation object */
    attestationObject: string;
    /** Base64url-encoded client data */
    clientDataJSON: string;
    transports?: AttestationResponseResponseTransportsItem[];
    publicKeyAlgorithm?: number;
};

export type AttestationResponseAuthenticatorAttachment =
    (typeof AttestationResponseAuthenticatorAttachment)[keyof typeof AttestationResponseAuthenticatorAttachment];

 
export const AttestationResponseAuthenticatorAttachment = {
    platform: 'platform',
    'cross-platform': 'cross-platform',
} as const;

export type AttestationResponseClientExtensionResults = { [key: string]: unknown };

export type AttestationResponse = {
    /** Credential ID */
    id: string;
    type: AttestationResponseType;
    response: AttestationResponseResponse;
    authenticatorAttachment?: AttestationResponseAuthenticatorAttachment;
    clientExtensionResults?: AttestationResponseClientExtensionResults;
};

export type AssertionResponseType = (typeof AssertionResponseType)[keyof typeof AssertionResponseType];

 
export const AssertionResponseType = {
    'public-key': 'public-key',
} as const;

export type AssertionResponseResponse = {
    /** Base64url-encoded authenticator data */
    authenticatorData: string;
    /** Base64url-encoded client data */
    clientDataJSON: string;
    /** Base64url-encoded signature */
    signature: string;
    /** Base64url-encoded user handle. Present only when the passkey was saved with passkeyUserHandle. */
    userHandle?: string;
};

export type AssertionResponseAuthenticatorAttachment =
    (typeof AssertionResponseAuthenticatorAttachment)[keyof typeof AssertionResponseAuthenticatorAttachment];

 
export const AssertionResponseAuthenticatorAttachment = {
    platform: 'platform',
    'cross-platform': 'cross-platform',
} as const;

export type AssertionResponseClientExtensionResults = { [key: string]: unknown };

export type AssertionResponse = {
    /** Credential ID */
    id: string;
    type: AssertionResponseType;
    response: AssertionResponseResponse;
    authenticatorAttachment?: AssertionResponseAuthenticatorAttachment;
    clientExtensionResults?: AssertionResponseClientExtensionResults;
};

export type BaseUserObject = {
    id: string;
    email: string;
    name: string;
};

export type UserObjectAllOf = {
    isAdmin?: boolean;
    domain?: string;
};

export type UserObject = BaseUserObject & UserObjectAllOf;

export type UserProfileObjectAllOf = {
    isAdmin?: boolean;
    domain?: string;
    /** URL of the user's Google profile picture */
    photoUrl?: string;
    /** User's notification tracking data */
    notifications?: Notification[];
};

export type UserProfileObject = UserObject & UserProfileObjectAllOf;

/**
 * Status of the notification
 */
export type NotificationStatus = (typeof NotificationStatus)[keyof typeof NotificationStatus];

 
export const NotificationStatus = {
    rejected: 'rejected',
    resolved: 'resolved',
} as const;

export type NotificationId = (typeof NotificationId)[keyof typeof NotificationId];

 
export const NotificationId = {
    extensionInstallation: 'extensionInstallation',
    adminOnboarding: 'adminOnboarding',
    passkeysOnboarding: 'passkeysOnboarding',
    ipadGiveaway: 'ipadGiveaway',
    largeWorkspaceTrialEnd: 'largeWorkspaceTrialEnd',
    reviewPrizepool: 'reviewPrizepool',
} as const;

export type Notification = {
    id: NotificationId;
    status: NotificationStatus;
    /** When the user dismissed the notification (if dismissed) */
    dismissedAt?: string;
};

export type GroupObject = {
    id?: string;
    email?: string;
    name?: string;
    visible?: boolean;
};

export type MemberEntityType = (typeof MemberEntityType)[keyof typeof MemberEntityType];

 
export const MemberEntityType = {
    USER: 'USER',
    GROUP: 'GROUP',
} as const;

export type MemberEntity = {
    id?: string;
    email?: string;
    type?: MemberEntityType;
};

export type TimestampDateTime = string;

export type HttpErrorErrorData = {
    message?: string;
    code?: string;
    /** Name of the authenticated user. The API returns it with error e2005. */
    name?: string;
    /** The plan limit that the request exceeded. The API returns it with errors e2000, e2002 and e2003. */
    limit?: number;
    /** The current usage that counts toward the limit. */
    current?: number;
};

export type HttpError = {
    message?: string;
    status?: number;
    errorCode?: string;
    errorData?: HttpErrorErrorData;
    errorClass?: string;
    stack?: string;
};

export type AccessToken = {
    accessToken?: string;
    /** Expiration of access token is 50 mins */
    expiration?: number;
};

export type OAuthCallback = {
    refresh_token?: string;
    access_token?: string;
    id_token?: string;
    expiry_date?: number;
    token_type?: string;
    scope?: string;
    isFirstLoginSaas?: boolean;
};

export type SecretInfoFile = {
    name: string;
    data: string;
};

export type SecretInfoShare = {
    until?: string;
    /** share id of the public share object */
    id?: string;
};

export type SecretInfo = {
    id: string;
    name: string;
    note?: string;
    tags?: string[];
    /**
     * The vault the secret belongs to, if any
     * @nullable
     */
    vaultId?: string | null;
    file?: SecretInfoFile;
    createdAt?: TimestampDateTime;
    updatedAt?: TimestampDateTime;
    createdBy?: BaseUserObject;
    userPermissions?: Permissions;
    sensitiveFields?: SensitiveField[];
    share?: SecretInfoShare;
    favicon?: string;
};

export type SensitiveField = (typeof SensitiveField)[keyof typeof SensitiveField];

 
export const SensitiveField = {
    password: 'password',
    privateKey: 'privateKey',
    cvvCode: 'cvvCode',
    TOTPsecret: 'TOTP.secret',
    passkey: 'passkey',
    credentials: 'credentials',
    secureNote: 'secureNote',
} as const;

export type PasswordSecretAllOfType = (typeof PasswordSecretAllOfType)[keyof typeof PasswordSecretAllOfType];

 
export const PasswordSecretAllOfType = {
    password: 'password',
} as const;

export type PasswordSecretAllOfTOTP = {
    algorithm?: string;
    codeLength?: number;
    period?: number;
};

export type PasswordSecretAllOfPasskey = {
    credentialId?: string;
    createdAt?: string;
};

export type PasswordSecretAllOf = {
    type?: PasswordSecretAllOfType;
    password?: string;
    hasTOTP?: boolean;
    TOTP?: PasswordSecretAllOfTOTP;
    /** Omitted on the Starter plan. */
    ignoreSecurityReport?: boolean;
    /** Omitted on the Starter plan. */
    securityLevel?: number;
    username?: string;
    web?: string;
    passkey?: PasswordSecretAllOfPasskey;
    /** Omitted on the Starter plan. */
    passwordUpdatedAt?: string;
    /** Omitted on the Starter plan. */
    passwordHashed?: string;
};

export type PasswordSecret = SecretInfo & PasswordSecretAllOf;

export type CardSecretAllOfType = (typeof CardSecretAllOfType)[keyof typeof CardSecretAllOfType];

 
export const CardSecretAllOfType = {
    paymentCard: 'paymentCard',
} as const;

export type CardSecretAllOf = {
    type?: CardSecretAllOfType;
    cardNumber?: string;
    cardholderName?: string;
    expirationDate?: string;
    cvvCode?: string;
};

export type CardSecret = SecretInfo & CardSecretAllOf;

export type APISecretAllOfType = (typeof APISecretAllOfType)[keyof typeof APISecretAllOfType];

 
export const APISecretAllOfType = {
    apiCredentials: 'apiCredentials',
} as const;

export type APISecretAllOf = {
    type?: APISecretAllOfType;
    username?: string;
    credentials?: string;
    hostname?: string;
};

export type APISecret = SecretInfo & APISecretAllOf;

export type DatabaseSecretAllOfType = (typeof DatabaseSecretAllOfType)[keyof typeof DatabaseSecretAllOfType];

 
export const DatabaseSecretAllOfType = {
    databaseCredentials: 'databaseCredentials',
} as const;

export type DatabaseSecretAllOf = {
    type?: DatabaseSecretAllOfType;
    username?: string;
    password?: string;
    server?: string;
    port?: number;
    databaseName?: string;
    databaseType?: string;
};

export type DatabaseSecret = SecretInfo & DatabaseSecretAllOf;

export type SSHSecretAllOfType = (typeof SSHSecretAllOfType)[keyof typeof SSHSecretAllOfType];

 
export const SSHSecretAllOfType = {
    sshKey: 'sshKey',
} as const;

export type SSHSecretAllOf = {
    type?: SSHSecretAllOfType;
    username?: string;
    privateKey?: string;
    publicKey?: string;
};

export type SSHSecret = SecretInfo & SSHSecretAllOf;

export type NoteSecretAllOfType = (typeof NoteSecretAllOfType)[keyof typeof NoteSecretAllOfType];

 
export const NoteSecretAllOfType = {
    secureNote: 'secureNote',
} as const;

export type NoteSecretAllOf = {
    type?: NoteSecretAllOfType;
    secureNote?: string;
};

export type NoteSecret = SecretInfo & NoteSecretAllOf;

export type PasswordSecretListResponseAllOfType =
    (typeof PasswordSecretListResponseAllOfType)[keyof typeof PasswordSecretListResponseAllOfType];

 
export const PasswordSecretListResponseAllOfType = {
    password: 'password',
} as const;

export type PasswordSecretListResponseAllOfTOTP = {
    algorithm?: string;
    codeLength?: number;
    period?: number;
};

export type PasswordSecretListResponseAllOf = {
    type?: PasswordSecretListResponseAllOfType;
    hasPassword?: boolean;
    hasTOTP?: boolean;
    TOTP?: PasswordSecretListResponseAllOfTOTP;
    /** Omitted on the Starter plan. */
    ignoreSecurityReport?: boolean;
    /** Omitted on the Starter plan. */
    securityLevel?: number;
    username?: string;
    web?: string;
};

export type PasswordSecretListResponse = SecretInfo & PasswordSecretListResponseAllOf;

export type CardSecretListResponseAllOfType = (typeof CardSecretListResponseAllOfType)[keyof typeof CardSecretListResponseAllOfType];

 
export const CardSecretListResponseAllOfType = {
    paymentCard: 'paymentCard',
} as const;

export type CardSecretListResponseAllOf = {
    type?: CardSecretListResponseAllOfType;
    cardNumber?: string;
    cardholderName?: string;
    expirationDate?: string;
};

export type CardSecretListResponse = SecretInfo & CardSecretListResponseAllOf;

export type APISecretListResponseAllOfType = (typeof APISecretListResponseAllOfType)[keyof typeof APISecretListResponseAllOfType];

 
export const APISecretListResponseAllOfType = {
    apiCredentials: 'apiCredentials',
} as const;

export type APISecretListResponseAllOf = {
    type?: APISecretListResponseAllOfType;
    username?: string;
    hostname?: string;
};

export type APISecretListResponse = SecretInfo & APISecretListResponseAllOf;

export type DatabaseSecretListResponseAllOfType =
    (typeof DatabaseSecretListResponseAllOfType)[keyof typeof DatabaseSecretListResponseAllOfType];

 
export const DatabaseSecretListResponseAllOfType = {
    databaseCredentials: 'databaseCredentials',
} as const;

export type DatabaseSecretListResponseAllOf = {
    type?: DatabaseSecretListResponseAllOfType;
    username?: string;
    server?: string;
    port?: number;
    databaseName?: string;
    databaseType?: string;
};

export type DatabaseSecretListResponse = SecretInfo & DatabaseSecretListResponseAllOf;

export type SSHSecretListResponseAllOfType = (typeof SSHSecretListResponseAllOfType)[keyof typeof SSHSecretListResponseAllOfType];

 
export const SSHSecretListResponseAllOfType = {
    sshKey: 'sshKey',
} as const;

export type SSHSecretListResponseAllOf = {
    type?: SSHSecretListResponseAllOfType;
    username?: string;
    publicKey?: string;
};

export type SSHSecretListResponse = SecretInfo & SSHSecretListResponseAllOf;

export type NoteSecretListResponseAllOfType = (typeof NoteSecretListResponseAllOfType)[keyof typeof NoteSecretListResponseAllOfType];

 
export const NoteSecretListResponseAllOfType = {
    secureNote: 'secureNote',
} as const;

export type NoteSecretListResponseAllOf = {
    type?: NoteSecretListResponseAllOfType;
    secureNote?: string;
};

export type NoteSecretListResponse = SecretInfo & NoteSecretListResponseAllOf;

export type Secret = PasswordSecret | CardSecret | APISecret | DatabaseSecret | SSHSecret | NoteSecret;

export type SecretList =
    | PasswordSecretListResponse
    | CardSecretListResponse
    | APISecretListResponse
    | DatabaseSecretListResponse
    | SSHSecretListResponse
    | NoteSecretListResponse;

export type BaseSecretInput = {
    name?: string;
    note?: string;
    tags?: string[];
    groups?: ReferenceToWrite[];
    whitelistUsers?: ReferenceToWrite[];
    /**
   * The vault the secret belongs to. Setting, changing or clearing it requires
WRITE on the secret and the editor role in the target vault (and, when moving
a secret out of a vault, the editor role in the source vault too).

   * @nullable
   */
    vaultId?: string | null;
};

export type PasswordSecretInputAllOfType = (typeof PasswordSecretInputAllOfType)[keyof typeof PasswordSecretInputAllOfType];

 
export const PasswordSecretInputAllOfType = {
    password: 'password',
} as const;

export type PasswordSecretInputAllOf = {
    type?: PasswordSecretInputAllOfType;
    username?: string;
    password?: string;
    web?: string;
    note?: string;
    /** Credential ID returned by /passkeys/register. When set, passkeyRpId and
passkeyOrigin must also be supplied. passkeyRpId is pinned to this credential
and enforced at authentication time.
 */
    passkeyCredentialId?: string;
    /** Relying party ID this passkey is registered for. Pinned at registration; required when passkeyCredentialId is set. Authentication accepts any origin whose host is this rpId or a subdomain of it. */
    passkeyRpId?: string;
    /** HTTPS origin this passkey was registered from. Required when passkeyCredentialId is set. Stored for reference; the rpId scope decides which origins can authenticate. */
    passkeyOrigin?: string;
    /** Base64url-encoded user.id the relying party supplied at registration (1-64 decoded bytes, no padding). Stored verbatim and returned as response.userHandle from authenticate-passkey so discoverable sign-in flows without allowCredentials can identify the account. */
    passkeyUserHandle?: string;
    TOTP?: string;
};

export type PasswordSecretInput = BaseSecretInput & PasswordSecretInputAllOf;

export type CardSecretInputAllOfType = (typeof CardSecretInputAllOfType)[keyof typeof CardSecretInputAllOfType];

 
export const CardSecretInputAllOfType = {
    paymentCard: 'paymentCard',
} as const;

export type CardSecretInputAllOf = {
    type?: CardSecretInputAllOfType;
    cardNumber?: string;
    cardholderName?: string;
    expirationDate?: string;
    cvvCode?: string;
};

export type CardSecretInput = BaseSecretInput & CardSecretInputAllOf;

export type APISecretInputAllOfType = (typeof APISecretInputAllOfType)[keyof typeof APISecretInputAllOfType];

 
export const APISecretInputAllOfType = {
    apiCredentials: 'apiCredentials',
} as const;

export type APISecretInputAllOf = {
    type?: APISecretInputAllOfType;
    username?: string;
    credentials?: string;
    hostname?: string;
};

export type APISecretInput = BaseSecretInput & APISecretInputAllOf;

export type DatabaseSecretInputAllOfType = (typeof DatabaseSecretInputAllOfType)[keyof typeof DatabaseSecretInputAllOfType];

 
export const DatabaseSecretInputAllOfType = {
    databaseCredentials: 'databaseCredentials',
} as const;

export type DatabaseSecretInputAllOf = {
    type?: DatabaseSecretInputAllOfType;
    username?: string;
    password?: string;
    server?: string;
    port?: number;
    databaseName?: string;
    databaseType?: string;
};

export type DatabaseSecretInput = BaseSecretInput & DatabaseSecretInputAllOf;

export type SSHSecretInputAllOfType = (typeof SSHSecretInputAllOfType)[keyof typeof SSHSecretInputAllOfType];

 
export const SSHSecretInputAllOfType = {
    sshKey: 'sshKey',
} as const;

export type SSHSecretInputAllOf = {
    type?: SSHSecretInputAllOfType;
    privateKey?: string;
    publicKey?: string;
};

export type SSHSecretInput = BaseSecretInput & SSHSecretInputAllOf;

export type SecureNoteSecretInputAllOfType = (typeof SecureNoteSecretInputAllOfType)[keyof typeof SecureNoteSecretInputAllOfType];

 
export const SecureNoteSecretInputAllOfType = {
    secureNote: 'secureNote',
} as const;

export type SecureNoteSecretInputAllOf = {
    type?: SecureNoteSecretInputAllOfType;
    secureNote?: string;
};

export type SecureNoteSecretInput = BaseSecretInput & SecureNoteSecretInputAllOf;

export type ReportItemLevel = string | number;

export type ReportItem = {
    total?: number;
    level?: ReportItemLevel;
    percentage?: string;
};

export type ClientId = {
    clientId?: string;
    firefoxLogin?: boolean;
};

export type PermissionsItem = (typeof PermissionsItem)[keyof typeof PermissionsItem];

 
export const PermissionsItem = {
    read: 'read',
    write: 'write',
    autofillOnly: 'autofillOnly',
    passkeyOnly: 'passkeyOnly',
    limited: 'limited',
} as const;

export type Permissions = PermissionsItem[];

export type ReferenceObjectWithoutPermissions = {
    groups?: GroupObject[];
    whitelistUsers?: UserObject[];
};

export type ReferenceObjectWithPermissionsGroupsItemAllOf = {
    accessPermissions?: Permissions;
};

export type ReferenceObjectWithPermissionsGroupsItem = GroupObject & ReferenceObjectWithPermissionsGroupsItemAllOf;

export type ReferenceObjectWithPermissionsWhitelistUsersItemAllOf = {
    accessPermissions?: Permissions;
};

export type ReferenceObjectWithPermissionsWhitelistUsersItem = UserObject & ReferenceObjectWithPermissionsWhitelistUsersItemAllOf;

export type ReferenceObjectWithPermissions = {
    groups?: ReferenceObjectWithPermissionsGroupsItem[];
    whitelistUsers?: ReferenceObjectWithPermissionsWhitelistUsersItem[];
};

export type ReferenceToWrite = {
    id?: string;
    accessPermissions?: Permissions;
};

/**
 * editor — manage secrets in the vault, manage members/roles and delete the
vault; grants WRITE on contained secrets (union with per-secret ACL).
viewer — view secrets only; grants READ on contained secrets.

 */
export type VaultRole = (typeof VaultRole)[keyof typeof VaultRole];

 
export const VaultRole = {
    editor: 'editor',
    viewer: 'viewer',
} as const;

export type VaultType = (typeof VaultType)[keyof typeof VaultType];

 
export const VaultType = {
    personal: 'personal',
    team: 'team',
} as const;

export type Vault = {
    id: string;
    name: string;
    type: VaultType;
    /** Empty for personal vaults (owner is implicit via createdBy) */
    users?: VaultMember[];
    groups?: VaultMember[];
    /** Number of secrets in the vault (before per-user access filtering) */
    secretsCount?: number;
    /** The caller's effective role in this vault (computed) */
    userRole?: VaultRole;
    createdBy?: BaseUserObject;
    createdAt?: TimestampDateTime;
    updatedAt?: TimestampDateTime;
};

export type VaultMember = {
    id: string;
    role: VaultRole;
    /** Display name resolved from the directory; absent when the member cannot be resolved */
    name?: string;
    /** Email resolved from the directory (user members only) */
    email?: string;
};

/**
 * The owner's current access status, or null if the owner is no longer known
 * @nullable
 */
export type PersonalVaultAdministrationOwnerStatus = AccessStatus | null;

export type PersonalVaultAdministration = {
    id: string;
    name: string;
    /** Number of secrets in the personal vault */
    secretsCount?: number;
    owner: BaseUserObject;
    /**
     * The owner's current access status, or null if the owner is no longer known
     * @nullable
     */
    ownerStatus?: PersonalVaultAdministrationOwnerStatus;
    /** Whether the vault is visible to its owner (false once the owner is offboarded) */
    visible?: boolean;
    createdAt?: TimestampDateTime;
    updatedAt?: TimestampDateTime;
};

export type VaultMemberToWrite = {
    id: string;
    role: VaultRole;
};

export type VaultInput = {
    name: string;
    users?: VaultMemberToWrite[];
    groups?: VaultMemberToWrite[];
};

export type VaultUpdateInput = {
    name?: string;
    /** Full replacement of the user member list */
    users?: VaultMemberToWrite[];
    /** Full replacement of the group member list */
    groups?: VaultMemberToWrite[];
};

export type UtmParamsOriginal = {
    utm_source?: string;
    utm_medium?: string;
    utm_campaign?: string;
};

export type UtmParamsFinal = {
    utm_source?: string;
    utm_medium?: string;
    utm_campaign?: string;
};

export type UtmParams = {
    original: UtmParamsOriginal;
    final: UtmParamsFinal;
};

export type BaseSettings = {
    /** Mirrors the LIMIT_ADMIN_PERMISSIONS deployment flag. When true, admins see and manage only their own and shared secrets and cannot filter secrets by user or group. Read-only. */
    limitAdminPermissions: boolean;
    /** @deprecated */
    defaultPermission?: SecretPermission;
    secretDefaultPermission?: PermissionType;
    sharingPermission?: SharingPermission;
    hiddenGroupsIds?: string[];
    subscription?: SubscriptionStatus;
    pricingModel?: PricingModel;
    trialEndTimestamp?: number;
    userCount?: number;
    /** Count of users with status=active in the administration table. Available in both single-domain and SaaS modes. */
    activeUserCount?: number;
    /** Billing email of the subscription */
    adminEmail?: string;
    /** Raw Stripe subscription status */
    stripeStatus?: string;
    /** When the subscription was or will be canceled */
    cancellationTimestamp?: number;
};

/**
 * Workspace settings an admin can change
 */
export type SettingsInput = {
    /** @deprecated */
    defaultPermission?: SecretPermission;
    secretDefaultPermission?: PermissionType;
    sharingPermission?: SharingPermission;
    hiddenGroupsIds?: string[];
};

export type AdminSettingsAllOf = {
    order?: StripeOrder;
};

export type AdminSettings = BaseSettings & AdminSettingsAllOf;

export type StripeOrderInterval = (typeof StripeOrderInterval)[keyof typeof StripeOrderInterval];

 
export const StripeOrderInterval = {
    year: 'year',
    month: 'month',
} as const;

/**
 * The tier for number of users the customer bought
 */
export type StripeOrderTier = {
    id?: string;
    description?: string;
};

export type StripeOrder = {
    interval?: StripeOrderInterval;
    /** Amount billed monthly in USD cents */
    amount?: number;
    billingEmail?: string;
    /** The tier for number of users the customer bought */
    tier?: StripeOrderTier;
};

export type SecretPermission = (typeof SecretPermission)[keyof typeof SecretPermission];

 
export const SecretPermission = {
    viewer: 'viewer',
    editor: 'editor',
    autofillOnly: 'autofillOnly',
    passkeyOnly: 'passkeyOnly',
} as const;

export type PermissionType = (typeof PermissionType)[keyof typeof PermissionType];

 
export const PermissionType = {
    write: 'write',
    read: 'read',
    autofillOnly: 'autofillOnly',
    passkeyOnly: 'passkeyOnly',
} as const;

export type SharingPermission = (typeof SharingPermission)[keyof typeof SharingPermission];

 
export const SharingPermission = {
    everyone: 'everyone',
    adminOnly: 'adminOnly',
    disallowed: 'disallowed',
} as const;

export type SubscriptionStatus = (typeof SubscriptionStatus)[keyof typeof SubscriptionStatus];

 
export const SubscriptionStatus = {
    free: 'free',
    active: 'active',
    'not-linked': 'not-linked',
    canceled: 'canceled',
    trial: 'trial',
} as const;

export type Currency = (typeof Currency)[keyof typeof Currency];

 
export const Currency = {
    eur: 'eur',
    usd: 'usd',
} as const;

export type PricingModel = (typeof PricingModel)[keyof typeof PricingModel];

 
export const PricingModel = {
    perUser: 'perUser',
    workspace: 'workspace',
} as const;

export type CheckoutRequest = {
    currency: Currency;
    pricingModel: PricingModel;
    /** The ID of the coupon to apply */
    couponId?: string;
    /** The client reference ID for the checkout */
    clientReferenceId?: string;
};

export type CheckoutResponse = {
    /** The generated checkout URL */
    url: string;
};

export type PriceTier = {
    amount?: number;
    /** @nullable */
    discount?: number | null;
    /** @nullable */
    discountedAmount?: number | null;
    from?: number;
    name?: string;
    /** @nullable */
    upTo?: number | null;
};

/**
 * Billing interval of the underlying subscription
 */
export type CustomerPricingInterval = (typeof CustomerPricingInterval)[keyof typeof CustomerPricingInterval];

 
export const CustomerPricingInterval = {
    month: 'month',
    year: 'year',
} as const;

export type CustomerPricing = {
    pricingModel: PricingModel;
    /**
     * Price per user in cents (when pricingModel=perUser)
     * @nullable
     */
    pricePerUser?: number | null;
    currentTier?: PriceTier;
    currency: string;
    /** Expected monthly bill in cents */
    expectedMonthlyBill: number;
    /** Billing interval of the underlying subscription */
    interval: CustomerPricingInterval;
    /** @nullable */
    userCount?: number | null;
    customerEmail?: string;
};

export type AdminPricingSettingsAllOf = {
    pricing?: CustomerPricing;
};

export type AdminPricingSettings = BaseSettings & AdminPricingSettingsAllOf;

/**
 * Format of the imported CSV file
 */
export type ImportFormat = (typeof ImportFormat)[keyof typeof ImportFormat];

 
export const ImportFormat = {
    passwd: 'passwd',
    lastpass: 'lastpass',
    nordpass: 'nordpass',
    onepassword: 'onepassword',
    dashlane: 'dashlane',
} as const;

export type ShareDetails = {
    sharerEmail?: string;
    until?: string;
};

export type SharedSecret = {
    secret: Secret;
    shareDetails: ShareDetails;
};

export type TOTPCode = {
    code?: string;
    validityStart?: number;
    validityEnd?: number;
};

export type AdministrationUser = {
    id?: string;
    email?: string;
    name?: string;
    status?: AccessStatus;
    groups?: GroupObject[];
    role?: UserRole;
    createdAt?: TimestampDateTime;
};

export type AdministrationGroup = {
    id?: string;
    name?: string;
    email?: string;
    members?: number;
    status?: AccessStatus;
    createdAt?: TimestampDateTime;
};

export type PagingInfo = {
    page?: number;
    limit?: number;
    count?: number;
};

/**
 * Status of the user
 */
export type AccessStatus = (typeof AccessStatus)[keyof typeof AccessStatus];

 
export const AccessStatus = {
    active: 'active',
    pending: 'pending',
    inactive: 'inactive',
} as const;

/**
 * Role of the user in the system
 */
export type UserRole = (typeof UserRole)[keyof typeof UserRole];

 
export const UserRole = {
    admin: 'admin',
    user: 'user',
} as const;

export type SecurityAuditSummary = {
    /** Password secrets the caller can access */
    total: number;
    /** Secrets with a password strength of 2 or lower */
    lowLevel: number;
    /** Secrets with a password older than 2 years */
    highAge: number;
    /** Secrets that share a password with another accessible secret */
    duplicities: number;
    /** Secrets with a password found in 10 or more leaks */
    manyLeaks: number;
};

/**
 * Security-audit summary counts
 */
export type SecurityAuditSummaryResponseResponse = SecurityAuditSummary;

/**
 * Vault detail
 */
export type VaultResponseResponse = Vault;

export type ListVaultsResponseResponse = {
    edges?: Vault[];
    pageInfo?: PagingInfo;
};

/**
 * List of personal vaults for administration
 */
export type ListPersonalVaultsAdministrationResponseResponse = PersonalVaultAdministration[];

/**
 * Successfully generated checkout URL
 */
export type CheckoutResponseBodyResponse = CheckoutResponse;

/**
 * Unauthorized access
 */
export type UnauthorizedErrorResponseResponse = HttpError;

/**
 * Validation isn't passing - unprocessable_entity
 */
export type UnprocessableEntityErrorResponseResponse = HttpError;

/**
 * Request not processed - bad_request
 */
export type BadRequestErrorResponseResponse = HttpError;

/**
 * Plan limits reached
 */
export type PlanLimitsErrorResponseResponse = HttpError;

/**
 * Email failed to sent
 */
export type FakeDoorPageErrorResponseResponse = HttpError;

/**
 * Entity not found - not_found
 */
export type NotFoundErrorResponseResponse = HttpError;

/**
 * Permission denied - forbidden
 */
export type ForbiddenErrorResponseResponse = HttpError;

/**
 * Method not allowed
 */
export type MethodNotAllowedResponseResponse = HttpError;

/**
 * Too many requests
 */
export type TooManyRequestsResponseResponse = HttpError;

/**
 * Precondition Required - User account is not active
 */
export type PreconditionRequiredErrorResponseResponse = HttpError;

/**
 * Bad gateway
 */
export type BadGatewayErrorResponseResponse = HttpError;

/**
 * OAuth Callback
 */
export type OAuthCallbackResponseResponse = OAuthCallback;

/**
 * Successful operation
 */
export type RefreshTokenResponseResponse = AccessToken;

/**
 * Successful operation
 */
export type ClientIdResponseResponse = ClientId;

/**
 * Successful operation
 */
export type CreateSecretResponseResponse = Secret;

export type ListSecretResponseResponseItem = SecretList & ReferenceObjectWithoutPermissions;

/**
 * Successful operation
 */
export type ListSecretResponseResponse = ListSecretResponseResponseItem[];

/**
 * Successful operation
 */
export type ExportSecretsResponseResponse = Blob;

/**
 * Successful operation
 */
export type ValidateSecretsResponseResponse = string;

export type ShareSecretResponseResponse = {
    until?: string;
    /** share id of the public share object */
    id?: string;
};

export type DetailSecretResponseResponseAllOf = {
    visibleToAll?: boolean;
    userPermissions?: Permissions;
};

export type DetailSecretResponseResponse = Secret & ReferenceObjectWithPermissions & DetailSecretResponseResponseAllOf;

/**
 * Successful opertaion
 */
export type UpdateSecretResponseResponse = Secret;

/**
 * Successful operation
 */
export type ListApiKeysResponseResponse = ApiKey[];

/**
 * API key created successfully
 */
export type CreateApiKeyResponseResponse = ApiKeyDetail;

/**
 * Successful operation
 */
export type GetApiKeyResponseResponse = ApiKey;

/**
 * Successful operation
 */
export type UpdateApiKeyResponseResponse = ApiKey;

/**
 * Successful opertaion
 */
export type GroupMembersResponseResponse = MemberEntity[];

export type ReportSecretsResponseResponseSecretsItem = SecretInfo & ReferenceObjectWithoutPermissions;

export type ReportSecretsResponseResponse = {
    reports?: ReportItem[];
    total?: number;
    secrets?: ReportSecretsResponseResponseSecretsItem[];
};

export type CollectFeedbackResponseResponse = {
    message?: string;
};

export type HiddenGroupsResponseResponse = {
    hiddenGroupsIds?: string[];
};

export type HelloResponseResponse = {
    message?: string;
    serverVersion?: string;
};

export type FirefoxLoginResponseResponse = { [key: string]: unknown };

/**
 * Successful operation
 */
export type SandboxResetResponseResponse = void;

/**
 * Successful operation
 */
export type SandboxContactsResponseResponse = void;

export type OrganizationDetailResponseResponseSettings = {
    defaultPermission?: string;
    sharingPermission?: string;
};

export type OrganizationDetailResponseResponse = {
    domain?: string;
    impersonationEmail?: string;
    originalDomain?: string;
    settings?: OrganizationDetailResponseResponseSettings;
};

export type ExtensionTrialResponseResponse = {
    createdAt?: string;
    daysLeft?: number;
    trialActive?: boolean;
    trialDeadline?: string;
};

/**
 * Successful operation
 */
export type AdminSettingsResponseResponse = AdminSettings;

/**
 * Successful operation
 */
export type AdminPricingSettingsResponseResponse = AdminPricingSettings;

/**
 * Successful operation
 */
export type SettingsResponseResponse = BaseSettings;

export type UserAdministrationResponseResponse = {
    edges?: AdministrationUser[];
    pageInfo?: PagingInfo;
};

export type ListGroupAdministrationResponseResponse = {
    edges?: AdministrationGroup[];
    pageInfo?: PagingInfo;
};

/**
 * Successful operation
 */
export type UpdateUserResponseResponse = AdministrationUser[];

/**
 * Successful operation
 */
export type UpdateGroupResponseResponse = AdministrationGroup[];

/**
 * Successful operation
 */
export type GroupAdministrationResponseResponse = AdministrationUser[];

export type CreateVaultRequestBodyBody = VaultInput;

export type UpdateVaultRequestBodyBody = VaultUpdateInput;

export type CheckoutRequestBodyBody = CheckoutRequest;

export type CallbackRequestBodyBodyOneSaasCheckoutType =
    (typeof CallbackRequestBodyBodyOneSaasCheckoutType)[keyof typeof CallbackRequestBodyBodyOneSaasCheckoutType];

 
export const CallbackRequestBodyBodyOneSaasCheckoutType = {
    starter: 'starter',
    workspace: 'workspace',
} as const;

export type CallbackRequestBodyBodyOne = {
    utmParams?: UtmParams;
    saasCheckoutType?: CallbackRequestBodyBodyOneSaasCheckoutType;
};

export type CallbackRequestBodyBodyTwo = {
    utmParams?: UtmParams;
};

export type CallbackRequestBodyBody = CallbackRequestBodyBodyOne | CallbackRequestBodyBodyTwo;

export type RefreshTokenRequestBodyBody = {
    refreshToken: string;
};

export type SignoutRequestBodyBody = {
    token?: string;
};

export type CreateSecretRequestBodyBody =
    | PasswordSecretInput
    | CardSecretInput
    | APISecretInput
    | DatabaseSecretInput
    | SSHSecretInput
    | SecureNoteSecretInput;

/**
 * CSV delimiter, defaults to ','
 */
export type ImportSecretsRequestBodyBodyDelimiter =
    (typeof ImportSecretsRequestBodyBodyDelimiter)[keyof typeof ImportSecretsRequestBodyBodyDelimiter];

 
export const ImportSecretsRequestBodyBodyDelimiter = {
    ';': ';',
    ',': ',',
} as const;

export type ImportSecretsRequestBodyBody = {
    /** Remove all secrets before importing them from csv file */
    replaceSecrets?: string;
    /** CSV delimiter, defaults to ',' */
    delimiter?: ImportSecretsRequestBodyBodyDelimiter;
    format?: ImportFormat;
    /** The csv file. Passwd format version 5 rows carry `vaultId`,
`vaultName` and `personal`. A row with `personal = true` is
skipped. Otherwise the secret is placed into the vault with
that id, or else into the single team vault with that name,
when the importing admin can edit it. When no vault matches
and `vaultName` is set, a new team vault of that name is
created with the importer as editor. A vault that exists but
is ambiguous by name or not editable by the importer is not
used and not re-created: a created secret gets no vault and
an updated secret keeps its current vault. An updated secret
changes or leaves its vault only when the importer can edit
the current vault. The validation (`POST /secret-validations`) and the
import return 402 e2007 when the vaults to create would
exceed the team vault plan limit, before anything is written.
A row without a vault reference is imported without a vault.
 */
    secrets?: Blob;
};

/**
 * CSV delimiter, defaults to ','
 */
export type ImportVaultSecretsRequestBodyBodyDelimiter =
    (typeof ImportVaultSecretsRequestBodyBodyDelimiter)[keyof typeof ImportVaultSecretsRequestBodyBodyDelimiter];

 
export const ImportVaultSecretsRequestBodyBodyDelimiter = {
    ';': ';',
    ',': ',',
} as const;

export type ImportVaultSecretsRequestBodyBody = {
    /** CSV delimiter, defaults to ',' */
    delimiter?: ImportVaultSecretsRequestBodyBodyDelimiter;
    format?: ImportFormat;
    /** The csv file. Every row is created in the vault given in the path. */
    secrets?: Blob;
};

/**
 * CSV delimiter, defaults to ','
 */
export type ValidateSecretsRequestBodyBodyDelimiter =
    (typeof ValidateSecretsRequestBodyBodyDelimiter)[keyof typeof ValidateSecretsRequestBodyBodyDelimiter];

 
export const ValidateSecretsRequestBodyBodyDelimiter = {
    ';': ';',
    ',': ',',
} as const;

export type ValidateSecretsRequestBodyBody = {
    /** CSV delimiter, defaults to ',' */
    delimiter?: ValidateSecretsRequestBodyBodyDelimiter;
    format?: ImportFormat;
    filename?: Blob;
};

export type UpdateSecretRequestBodyBody =
    | PasswordSecretInput
    | CardSecretInput
    | APISecretInput
    | DatabaseSecretInput
    | SSHSecretInput
    | SecureNoteSecretInput;

export type UpdateTagRequestBodyBody = {
    newName: string;
};

export type CollectFeedbackRequestBodyBodyFeedback =
    (typeof CollectFeedbackRequestBodyBodyFeedback)[keyof typeof CollectFeedbackRequestBodyBodyFeedback];

 
export const CollectFeedbackRequestBodyBodyFeedback = {
    satisfied: 'satisfied',
    unsatisfied: 'unsatisfied',
    'no-response': 'no-response',
} as const;

export type CollectFeedbackRequestBodyBody = {
    feedback: CollectFeedbackRequestBodyBodyFeedback;
};

export type SandboxContactsRequestBodyBody = {
    email: string;
    utmParams?: UtmParams;
};

export type SettingsRequestBodyBody = SettingsInput;

export type UpdateNotificationRequestBodyBody = {
    status: NotificationStatus;
};

export type CreateApiKeyRequestBodyBody = ApiKeyInput;

export type UpdateApiKeyRequestBodyBody = ApiKeyInput;

export type CodeParameterParameter = string;

/**
 * Filter for contacts list
 */
export type QueryParameter = string;

/**
 * Show only visible groups
 */
export type OnlyVisibleParameter = boolean;

/**
 * Token for next page
 */
export type NextPageTokenParameter = string;

/**
 * View secrets as given user (admins only)
 */
export type UserIdParameter = string;

/**
 * View secrets as given group (admins only)
 */
export type GroupIdParameter = string;

/**
 * Return only secrets contained in the given vault (caller must be a vault member)
 */
export type VaultIdParameter = string;

export type GetTokensParams = {
    code: CodeParameterParameter;
};

export type UpdateNotificationPathParameters = {
    notificationId: string;
};
export type ListSecretParams = {
    /**
     * View secrets as given user (admins only)
     */
    userId?: UserIdParameter;
    /**
     * View secrets as given group (admins only)
     */
    groupId?: GroupIdParameter;
    /**
     * Return only secrets contained in the given vault (caller must be a vault member)
     */
    vaultId?: VaultIdParameter;
};

export type SecretDetailPathParameters = {
    id: string;
};
export type SecretUpdatePathParameters = {
    id: string;
};
export type SecretDeletePathParameters = {
    id: string;
};
export type TOTPDetailPathParameters = {
    id: string;
};
export type TOTPDetail200Item = {
    code?: string;
    validityStart?: number;
    validityEnd?: number;
};

export type ShareSecretPathParameters = {
    id: string;
};
export type UnshareSecretPathParameters = {
    id: string;
};
export type GetSharedSecretPathParameters = {
    shareId: string;
};
export type RefreshSharedSecretPathParameters = {
    shareId: string;
};
export type GetSharedSecretTOTPPathParameters = {
    shareId: string;
};
export type ListVaultsParams = {
    /**
     * Case-insensitive substring match on the vault name
     */
    search?: string;
    /**
     * Comma-separated user IDs; matches vaults having any of them as a member
     */
    users?: string;
    /**
     * Comma-separated group IDs; matches vaults having any of them as a member
     */
    groups?: string;
    /**
     * Keep only vaults of the given type
     */
    type?: VaultType;
    /**
     * Field to order by
     */
    orderBy?: ListVaultsOrderBy;
    /**
     * Order direction
     */
    orderDirection?: ListVaultsOrderDirection;
    /**
     * Page number
     * @minimum 1
     */
    page?: number;
    /**
     * Number of items per page
     * @maximum 100
     */
    limit?: number;
};

export type ListVaultsOrderBy = (typeof ListVaultsOrderBy)[keyof typeof ListVaultsOrderBy];

 
export const ListVaultsOrderBy = {
    name: 'name',
} as const;

export type ListVaultsOrderDirection = (typeof ListVaultsOrderDirection)[keyof typeof ListVaultsOrderDirection];

 
export const ListVaultsOrderDirection = {
    asc: 'asc',
    desc: 'desc',
} as const;

export type VaultDetailPathParameters = {
    vaultId: string;
};
export type UpdateVaultPathParameters = {
    vaultId: string;
};
export type DeleteVaultPathParameters = {
    vaultId: string;
};
export type ImportVaultSecretsPathParameters = {
    vaultId: string;
};
export type ExportVaultSecretsPathParameters = {
    vaultId: string;
};
export type ValidateVaultSecretsPathParameters = {
    vaultId: string;
};
export type TagUpdatePathParameters = {
    tagName: string;
};
export type TagUpdate200 = {
    updated?: number;
};

export type TagDeletePathParameters = {
    tagName: string;
};
export type ShowGroupInSecretsPathParameters = {
    groupId: string;
};
export type HideGroupFromSecretsPathParameters = {
    groupId: string;
};
export type GroupsQueryParams = {
    /**
     * Filter for contacts list
     */
    query?: QueryParameter;
    /**
     * Token for next page
     */
    nextPageToken?: NextPageTokenParameter;
    /**
     * Show only visible groups
     */
    onlyVisible?: OnlyVisibleParameter;
};

export type GroupsQuery200Metadata = {
    nextPageToken?: string;
};

export type GroupsQuery200 = {
    data?: GroupObject[];
    metadata?: GroupsQuery200Metadata;
};

export type GroupMembersPathParameters = {
    groupId: string;
};
export type ContactListParams = {
    /**
     * Filter for contacts list
     */
    query?: QueryParameter;
};

export type ContactQueryParams = {
    /**
     * Filter for contacts list
     */
    query?: QueryParameter;
    /**
     * Token for next page
     */
    nextPageToken?: NextPageTokenParameter;
};

export type ContactQuery200Metadata = {
    nextPageToken?: string;
};

export type ContactQuery200 = {
    data?: UserObject[];
    metadata?: ContactQuery200Metadata;
};

export type ResetSandboxParams = {
    /**
     * Generate secrets or use seed file.
     */
    generateSecrets?: boolean;
};

export type OrganizationDetailPathParameters = {
    domain: string;
};
export type AuthenticatePasskeyPathParameters = {
    secretId: string;
};
export type ListUsersAdministrationParams = {
    /**
     * Search users by name or email
     */
    search?: string;
    /**
     * Filter users by status
     */
    status?: AccessStatus;
    /**
     * Filter users by role
     */
    role?: UserRole;
    /**
     * Comma-separated list of group IDs to filter by. If omitted, all groups are returned.
     */
    groups?: string;
    /**
     * Field to order by
     */
    orderBy?: ListUsersAdministrationOrderBy;
    /**
     * Order direction
     */
    orderDirection?: ListUsersAdministrationOrderDirection;
    /**
     * Page number
     * @minimum 1
     */
    page?: number;
    /**
     * Number of items per page
     * @maximum 100
     */
    limit?: number;
};

export type ListUsersAdministrationOrderBy = (typeof ListUsersAdministrationOrderBy)[keyof typeof ListUsersAdministrationOrderBy];

 
export const ListUsersAdministrationOrderBy = {
    name: 'name',
    email: 'email',
    role: 'role',
} as const;

export type ListUsersAdministrationOrderDirection =
    (typeof ListUsersAdministrationOrderDirection)[keyof typeof ListUsersAdministrationOrderDirection];

 
export const ListUsersAdministrationOrderDirection = {
    asc: 'asc',
    desc: 'desc',
} as const;

export type UpdateUsersAdministrationBody = {
    /** List of user IDs to update */
    userIds?: string[];
    status?: AccessStatus;
    role?: UserRole;
};

export type ListGroupsAdministrationParams = {
    /**
     * Search groups by name or email
     */
    search?: string;
    /**
     * Filter groups by status
     */
    status?: AccessStatus;
    /**
     * Field to order by
     */
    orderBy?: ListGroupsAdministrationOrderBy;
    /**
     * Order direction
     */
    orderDirection?: ListGroupsAdministrationOrderDirection;
    /**
     * Page number
     * @minimum 1
     */
    page?: number;
    /**
     * Number of items per page
     * @maximum 100
     */
    limit?: number;
};

export type ListGroupsAdministrationOrderBy = (typeof ListGroupsAdministrationOrderBy)[keyof typeof ListGroupsAdministrationOrderBy];

 
export const ListGroupsAdministrationOrderBy = {
    name: 'name',
    email: 'email',
    members: 'members',
} as const;

export type ListGroupsAdministrationOrderDirection =
    (typeof ListGroupsAdministrationOrderDirection)[keyof typeof ListGroupsAdministrationOrderDirection];

 
export const ListGroupsAdministrationOrderDirection = {
    asc: 'asc',
    desc: 'desc',
} as const;

export type UpdateGroupsAdministrationBody = {
    /** List of group IDs to update */
    groupIds?: string[];
    status?: AccessStatus;
};

export type DeletePersonalVaultAdministrationPathParameters = {
    vaultId: string;
};
export type GetApiKeyPathParameters = {
    apiKeyId: string;
};
export type UpdateApiKeyPathParameters = {
    apiKeyId: string;
};
export type DeleteApiKeyPathParameters = {
    apiKeyId: string;
};
export type PublicListSecretsParams = {
    /**
     * View secrets as given user (admins only)
     */
    userId?: UserIdParameter;
    /**
     * View secrets as given group (admins only)
     */
    groupId?: GroupIdParameter;
};

export type PublicGetSecretPathParameters = {
    id: string;
};
export type PublicUpdateSecretPathParameters = {
    id: string;
};
export type PublicDeleteSecretPathParameters = {
    id: string;
};
